<template>
  <v-combobox
    v-model="proAccountPriceOptionsStrings"
    :label="t('addSupervisorOrgDialog.proAccountPriceOptions')"
    :rules="[validatePriceOptions]"
    type="number"
    min="0"
    max="99999.99"
    multiple
    chips
    closable-chips
    prepend-inner-icon="mdi-currency-eur"
    hide-details="auto"
    variant="outlined"
  ></v-combobox>
</template>

<script setup lang="ts">
import { useI18n } from "@/composables/useI18n";
import { priceOptionsSchemaI18n } from "@aircap/common/schemas";
import { computed } from "vue";

const { t } = useI18n();
const proAccountPriceOptions = defineModel<number[]>({ required: true });

const proAccountPriceOptionsStrings = computed({
  get: () => proAccountPriceOptions.value.map((n) => n.toFixed(2)),
  set: (values: string[]) => {
    const numbers = values
      .map((v) => parseFloat(v))
      .filter((n) => !isNaN(n))
      .sort((a, b) => a - b);
    proAccountPriceOptions.value = numbers;
  },
});

const validatePriceOptions = (options: string[]) => {
  const numbers = options.map((v) => parseFloat(v));
  const result = priceOptionsSchemaI18n(t).safeParse(numbers);

  if (!result.success) {
    return result.error.issues[0]?.message ?? "Invalid price options";
  }

  return true;
};
</script>
